import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=37666bfe&scoped=true&"
import script from "./Lessons.vue?vue&type=script&lang=js&"
export * from "./Lessons.vue?vue&type=script&lang=js&"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=37666bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37666bfe",
  null
  
)

export default component.exports